import {
    GET_ERRORS, SUCCESS_ALERT
} from './type';
import Products from '../Models/Products';

export const AffiliatorRequest = (data, history) => dispatch => {
    // let i=[];
    Products.saveRequest(data)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                // alert('リクエストありがとうございます！提案があると通知されます。')
                // history.push();
                history.push({
                    pathname: '/affiliator-buyer-request-home',
                    state: { flag: SUCCESS_ALERT }
                });
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: res.data.message
                })
            }

        })
        .catch(
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: res.data.message
            // })
            // err=>this.setState({errors:err.response.data})
        )
    // return {
    //     type: SELLER_LOGIN,
    //     payload: sellerData,
    // }
};
